import React, { useRef, useEffect, useState } from "react";
import axios from "axios";
import scratchBanner from "../assets/images/sacratchBanner.jpeg";
import {
  ADANI_COLOR_PALATE,
  ACC_COLOR_PALATE,
  AMBUJA_COLOR_PALATE,
  DARPAN_COLOR_PALATE,
} from "../constants/common";
import ProfileService from "../services/Profile";

const ScratchCardImage = ({
  imgUrl,
  width = 320,
  height = 220,
  revealThreshold = 40,
  onComplete = () => {},
  isScratchable = false,
  rewardText,
  gift_name,
  selfieId
}) => {
  const canvasRef = useRef(null);
  const isDrawing = useRef(false);
  const lastPoint = useRef({ x: 0, y: 0 });
  const [revealed, setRevealed] = useState(false);
  
  const palate = ADANI_COLOR_PALATE;

  useEffect(() => {
    if (!revealed) {
      initCanvasBlack();
    }
  }, [revealed, width, height]);

  // Draw a black overlay for scratching
  const initCanvasBlack = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    canvas.width = width;
    canvas.height = height;
    ctx.globalCompositeOperation = "source-over";
    ctx.fillStyle = "rgba(0,0,0,0.85)";
    ctx.fillRect(0, 0, width, height);
    ctx.globalCompositeOperation = "destination-out";
  };

  const getXY = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();

    if (e.touches) {
      return {
        x: e.touches[0].clientX - rect.left,
        y: e.touches[0].clientY - rect.top,
      };
    }

    return {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top, 
    };
  };

  const start = (e) => {
    isDrawing.current = true;
    lastPoint.current = getXY(e);
  };

  const stop = () => {
    isDrawing.current = false;
    checkReveal();
  };

  const draw = (e) => {
    if (!isDrawing.current || revealed || !isScratchable) return;

    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = getXY(e);

    ctx.lineWidth = 25;
    ctx.lineCap = "round";

    ctx.beginPath();
    ctx.moveTo(lastPoint.current.x, lastPoint.current.y);
    ctx.lineTo(x, y);
    ctx.stroke();

    lastPoint.current = { x, y };
  };

  const checkReveal = async () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const pixels = ctx.getImageData(0, 0, width, height).data;

    let transparent = 0;
    for (let i = 3; i < pixels.length; i += 4) {
      if (pixels[i] === 0) transparent++;
    }

    const percent = (transparent / (pixels.length / 4)) * 100;

    if (percent > revealThreshold) {
      ctx.clearRect(0, 0, width, height);
      setRevealed(true);
      onComplete();
      try {
        const res = await ProfileService.scratchStatus(selfieId);
      } catch (err) {
        console.error("Error from scratch status API:");
      }

    }
  };

  return (
    <div
      style={{
        position: "relative",
        width,
        height,
        margin: "1rem auto",
        borderRadius: "16px",
        overflow: "hidden",
      }}
    >
      {/* 🎯 Dynamic Image (Hidden Layer) */}
      <div style={{ position: "relative", width: "100%", height: "100%" }}>
        <img
          src={scratchBanner}
          alt="Reward"
          style={{
            width: "100%",
            height: "100%",
            // objectFit: "cover",
            borderRadius: "16px",
          }}
        />
        {/* Show gift_name on the image only after scratch is complete */}
        {revealed && isScratchable && gift_name && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              pointerEvents: "none",
              zIndex: 1,
            }}
          >
            <span
              style={{
                color: "#fff",
                fontWeight: "bold",
                fontSize: "2rem",
                textAlign: "center",
                textShadow: "0 2px 8px rgba(0,0,0,0.7)",
                // background: "rgba(216, 209, 209, 0.3)",
                borderRadius: "12px",
                padding: "0.5rem 2rem",
              }}
            >
              {gift_name}
            </span>
          </div>
        )}
      </div>

      {/* Black overlay and reward text always, overlay is scratchable if isScratchable is true */}
      {!revealed && (
        <>
          <canvas
            ref={canvasRef}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              cursor: isScratchable ? "grab" : "not-allowed",
              borderRadius: "16px",
              zIndex: 2,
            }}
            onMouseDown={isScratchable ? start : undefined}
            onMouseUp={isScratchable ? stop : undefined}
            onMouseMove={isScratchable ? draw : undefined}
            onMouseLeave={isScratchable ? stop : undefined}
            onTouchStart={isScratchable ? start : undefined}
            onTouchEnd={isScratchable ? stop : undefined}
            onTouchMove={isScratchable ? draw : undefined}
          />
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              pointerEvents: "none",
              zIndex: 3,
            }}
          >
            <span
              style={{
                color: "#fff",
                fontWeight: "bold",
                fontSize: "1.2rem",
                textAlign: "center",
                padding: "0 1rem",
                textShadow: "0 2px 8px rgba(0,0,0,0.7)",
              }}
            >
              {rewardText}
            </span>
          </div>
        </>
      )}
    </div>
  );
};

export default ScratchCardImage;

